// export const Config = {
//   API_URL: 'http://localhost:9090/',
// };

export const CAPTCHA_KEY = '6LdUGUIoAAAAAFzkGw20hHTL96HP9t_jBl1ltQWB';

//export const Config = { API_URL: 'http://65.109.123.57:9090/' };

export const Config = { API_URL: 'https://automaticdomainsearch.com/domain' };
